import styled, { css } from 'styled-components';

const grid = css`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 430px 1fr;
    align-items: center;
  }
`;

const Wrapper = styled.div<any>`
  position: relative;
  ${(props) => props.grid && grid};
  padding: ${(props) => props.padding};
  padding-top: ${(props) => props.paddingTop};
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.marginTop};
`;

export default Wrapper;
